import activityTypes from 'helpers/enums/activityTypes'

export default {
	type: activityTypes.NONE_QUESTION,
	entity: {},
}
